export default __webpack_public_path__ + "static/media/ldo_NEG_FLOAT_ADJ_nEN_nCff.137458cd.svg";